import type { ComponentPropsWithoutRef } from 'react';
import GiftIcon from '@/app/assets/imgs/gift-icon.svg';

export const EarnCreditsIcon = ({ className, ...props }: ComponentPropsWithoutRef<'img'>) => (
  <img alt="" aria-hidden="true" className={className} src={GiftIcon.src} {...props} />
);
